const developerPaymentPopulate = { data: [], loading: true };

export const GetDeveloperPaymentPopulateRed = (state = developerPaymentPopulate, action) => {
  switch (action.type) {
    case "get_developerPaymentPopulate":
      return {
        data: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
